export const blockIconsTextformattingTaskNew = (
	<span className='material-symbols-outlined'>task</span>
);
